import { Box, AspectRatio } from '@chakra-ui/react';
import { ComponentVideo } from '@cms/graphql/types.generated';

type Props = Pick<ComponentVideo, 'video'>;

export const ArticleVideo: React.FC<Props> = ({ video }) => (
  <Box mt={['xl', null, '2xl']}>
    <AspectRatio ratio={16 / 9} maxW="100%">
      <iframe src={`https://player.vimeo.com/video/${video}`} frameBorder="0" allowFullScreen />
    </AspectRatio>
  </Box>
);
